import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { EventFiltersActionTypes, EventFiltersActions } from '../actions/event-filters.actions';


@Injectable()
export class EventFiltersEffects {
  private actions$ = inject(Actions);
  loadEventFilterss$ = createEffect(() => this.actions$.pipe(
    ofType(EventFiltersActionTypes.LoadEventFilterss),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor() {}

}
